import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import TriangulationPageUI from './TriangulationPageUI.js'

class TriangulationPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      accountYearList: null,
      accountMonthGstList: null,
      accountMonthBankList: null,
      netCashFlowList: null,
      bankChecked: true,
      gstChecked: true,
      pnlChecked: false,
      selectedYear: null,
      selectedSection: null,
      checked: false,
      startYear: '',
      startMonth: '',
      endYear: '',
      endMonth: '',
      yearList: [],
      monthList: [],
      lastNMonths: '',
      submitted: false,
      showDetails: false,
      showNetProfit: false,
      showGstData: false
    }
  }

  render() {
    let monthList = [
      { value: '01', label: 'Jan' },
      { value: '02', label: 'Feb' },
      { value: '03', label: 'Mar' },
      { value: '04', label: 'Apr' },
      { value: '05', label: 'May' },
      { value: '06', label: 'Jun' },
      { value: '07', label: 'Jul' },
      { value: '08', label: 'Aug' },
      { value: '09', label: 'Sep' },
      { value: '10', label: 'Oct' },
      { value: '11', label: 'Nov' },
      { value: '12', label: 'Dec' },
    ]
    let lastNMonthsList = [
      { value: '', label: 'From april' },
      { value: '6', label: 'Last 6 months' },
      { value: '12', label: 'Last 12 months' }
    ]
    return (
      <TriangulationPageUI
        context={this.props.context}
        account={this.state.account}
        nMonthGstTotal={this.state.nMonthGstTotal}
        nMonthBankTotal={this.state.nMonthBankTotal}
        accountYearList={this.state.accountYearList}
        financialsFromMCA={this.state.financialsFromMCA}
        accountMonthGstList={this.state.accountMonthGstList}
        accountMonthBankList={this.state.accountMonthBankList}
        onRefreshClick={this.onRefreshClick}
        bankChecked={this.state.bankChecked}
        gstChecked={this.state.gstChecked}
        pnlChecked={this.state.pnlChecked}
        onBankClick={() => { this.setState({ bankChecked: !this.state.bankChecked }) }}
        onGSTClick={() => { this.setState({ gstChecked: !this.state.gstChecked }) }}
        onPnLClick={() => { this.setState({ pnlChecked: !this.state.pnlChecked }) }}
        onShowMonthly={this.onShowMonthly}
        selectedYear={this.state.selectedYear}
        selectedSection={this.state.selectedSection}
        monthList={monthList}
        yearList={this.state.yearList}
        startYear={this.state.startYear}
        startMonth={this.state.startMonth}
        endYear={this.state.endYear}
        endMonth={this.state.endMonth}
        onStartYearChange={this.onStartYearChange}
        onStartMonthChange={this.onStartMonthChange}
        onEndYearChange={this.onEndYearChange}
        onEndMonthChange={this.onEndMonthChange}
        lastNMonths={this.state.lastNMonths}
        lastNMonthsList={lastNMonthsList}
        onLastNMonthsChange={this.onLastNMonthsChange}
        onSubmit={this.onSubmit}
        submitted={this.state.submitted}
        onClearClick={this.onClearClick}
        showDetails={this.state.showDetails}
        onShowDetails={() => { this.setState({ showDetails: !this.state.showDetails }) }}
        showNetProfit={this.state.showNetProfit}
        onShowNetProfit={() => { this.setState({ showNetProfit: !this.state.showNetProfit }) }}
        //
        showGstData={this.state.showGstData}
        onShowGstDataClick={() => { this.setState({ showGstData: !this.state.showGstData }) }}
        //
        netCashFlowList={this.state.netCashFlowList}
      />
    )
  }

  onShowMonthly = (event) => {
    let year = event.currentTarget.getAttribute('data-year')
    let section = event.currentTarget.getAttribute('data-section')
    if (year === this.state.selectedYear && section === this.state.selectedSection)
      year = null
    this.setState({ selectedYear: year, selectedSection: section })
  }

  onStartYearChange = (option) => {
    let context = this.props.context
    this.setState({ startYear: option.value })
  }

  onStartMonthChange = (option) => {
    let context = this.props.context
    this.setState({ startMonth: option.value })
  }

  onEndYearChange = (option) => {
    let context = this.props.context
    this.setState({ endYear: option.value })
  }

  onEndMonthChange = (option) => {
    let context = this.props.context
    this.setState({ endMonth: option.value })
  }

  onLastNMonthsChange = (option) => {
    let context = this.props.context
    this.setState({ lastNMonths: option.value })
    this.getLastNMonthsGstTriangulation(context, option.value)
    this.getLastNMonthsBankTriangulation(context, option.value)
  }

  componentDidMount() {
    let context = this.props.context
    this.getYears(context)
    this.getAccounts(context)
    this.getTriangulations(context)
    this.getLastNMonthsGstTriangulation(context, '')
    this.getLastNMonthsBankTriangulation(context, '')
    this.getNetCashFlow(context, null, null, 12)
  }

  getYears(context) {
    let cacheManager = new CacheManager({
      resource: `/api/pub/years`,
      cacheKey: CacheKeys.Years(),
      callback: this.getYearsCallback,
      ttlInSecs: 0
    })
    cacheManager.getObject2(context)
  }

  getYearsCallback = (response) => {
    let yearList = response.yearList.map((years) => {
      return { value: years, label: years }
    })
    this.setState({ errorList: response.errorList, yearList: yearList })
  }

  getTriangulations(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}/cash/gst-bank/monthly`,
      cacheKey: CacheKeys.Triangulations(this.props.match.params.accountId),
      callback: this.getTriangulationsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getTriangulationsCallback = (response) => {
    this.setState({ accountYearList: response.accountYearList, financialsFromMCA: response.financialsFromMCA, submitted: false, cleared: false })
  }

  getAccounts(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}`,
      cacheKey: CacheKeys.Accounts(this.props.match.params.accountId),
      callback: this.getAccountsCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getAccountsCallback = (response) => {
    this.setState({ account: response.account })
  }

  getLastNMonthsGstTriangulation(context, lastNMonths) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}/cash/gst-bank/lastNMonths`,
      cacheKey: CacheKeys.TriangulationNMonths(this.props.match.params.accountId, lastNMonths, true),
      callback: this.getLastNMonthsGstTriangulationCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context, null, {
      months: lastNMonths,
      forGSTData: true
    })
  }

  getLastNMonthsGstTriangulationCallback = (response) => {
    this.setState({ accountMonthGstList: response.accountMonthList, nMonthGstTotal: response, submitted: false, cleared: false })
  }

  getLastNMonthsBankTriangulation(context, lastNMonths) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}/cash/gst-bank/lastNMonths`,
      cacheKey: CacheKeys.TriangulationNMonths(this.props.match.params.accountId, lastNMonths, false),
      callback: this.getLastNMonthsBankTriangulationCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context, null, {
      months: lastNMonths,
      forGSTData: false
    })
  }

  getLastNMonthsBankTriangulationCallback = (response) => {
    this.setState({ accountMonthBankList: response.accountMonthList, nMonthBankTotal: response, submitted: false, cleared: false })
  }

  onSubmit = () => {
    if (!this.state.startYear || !this.state.startMonth || !this.state.endYear || !this.state.endMonth) {
      return
    }
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      lastNMonths: '',
      submitted: true
    })

    let fromYearMonth = this.state.startYear + '-' + this.state.startMonth
    let toYearMonth = this.state.endYear + '-' + this.state.endMonth
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}/cash/gst-bank/monthly`,
      cacheKey: CacheKeys.Triangulations(this.props.match.params.accountId, fromYearMonth, toYearMonth),
      callback: this.getTriangulationsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(this.props.context, null, {
      fromYearMonth: fromYearMonth,
      toYearMonth: toYearMonth
    })

    let cacheManager1 = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}/cash/gst-bank/lastNMonths`,
      cacheKey: CacheKeys.TriangulationNMonths(this.props.match.params.accountId, fromYearMonth, toYearMonth, true),
      callback: this.getLastNMonthsGstTriangulationCallback,
      ttlInSecs: 0
    })
    cacheManager1.getObject2(this.props.context, null, {
      fromYearMonth: fromYearMonth,
      toYearMonth: toYearMonth,
      forGSTData: true
    })

    let cacheManager2 = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}/cash/gst-bank/lastNMonths`,
      cacheKey: CacheKeys.TriangulationNMonths(this.props.match.params.accountId, fromYearMonth, toYearMonth, false),
      callback: this.getLastNMonthsBankTriangulationCallback,
      ttlInSecs: 0
    })
    cacheManager2.getObject2(this.props.context, null, {
      fromYearMonth: fromYearMonth,
      toYearMonth: toYearMonth,
      forGSTData: false
    })

    this.getNetCashFlow(this.props.context, fromYearMonth, toYearMonth)
  }

  onClearClick = () => {
    let cleared = this.state.cleared
    if (cleared)
      return
    this.setState({
      successMsg: null,
      errorList: [],
      cleared: true,
      startYear: '',
      startMonth: '',
      endYear: '',
      endMonth: '',
      lastNMonths: ''
    })
    this.getTriangulations(this.props.context)
    this.getLastNMonthsGstTriangulation(this.props.context, '')
    this.getLastNMonthsBankTriangulation(this.props.context, '')
    this.getNetCashFlow(this.props.context, null, null)
  }

  onRefreshClick = () => {
    let context = this.props.context

    // Build cache key for Net Cash Flow based on current date filter state
    let netCashFlowCacheKey = null
    if (this.state.startYear && this.state.startMonth && this.state.endYear && this.state.endMonth) {
      let fromYearMonth = this.state.startYear + '-' + this.state.startMonth
      let toYearMonth = this.state.endYear + '-' + this.state.endMonth
      netCashFlowCacheKey = `${fromYearMonth}:${toYearMonth}`
    }

    CacheManager.removeObject(CacheKeys.Triangulations(this.props.match.params.accountId))
    CacheManager.removeObject(CacheKeys.TriangulationNMonths(this.props.match.params.accountId, this.state.lastNMonths, true))
    CacheManager.removeObject(CacheKeys.TriangulationNMonths(this.props.match.params.accountId, this.state.lastNMonths, false))
    CacheManager.removeObject(CacheKeys.NetCashFlow(this.props.match.params.accountId, netCashFlowCacheKey))

    this.setState({ accountYearList: null, accountMonthGstList: null, accountMonthBankList: null, netCashFlowList: null }, () => {
      this.getLastNMonthsGstTriangulation(context, '')
      this.getLastNMonthsBankTriangulation(context, '')

      // Reload Net Cash Flow with current date filter if any
      if (this.state.startYear && this.state.startMonth && this.state.endYear && this.state.endMonth) {
        let fromYearMonth = this.state.startYear + '-' + this.state.startMonth
        let toYearMonth = this.state.endYear + '-' + this.state.endMonth
        this.getNetCashFlow(context, fromYearMonth, toYearMonth)
      } else {
        this.getNetCashFlow(context, null, null, 12)
      }

      this.recalculate(context)
    }
    )
  }

  recalculate(context) {
    RestApiUtils.post(this.props.context,
      `/api/su/accounts/${this.props.match.params.accountId}/cash/gst-bank`,
      this.onRecalculateCallback, {}
    );
  }

  onRecalculateCallback = (response) => {
    this.getTriangulations(this.props.context)
  }

  getNetCashFlow(context, fromYearMonth, toYearMonth, months) {
    let cacheKey = fromYearMonth && toYearMonth
      ? CacheKeys.NetCashFlow(this.props.match.params.accountId, `${fromYearMonth}:${toYearMonth}`)
      : CacheKeys.NetCashFlow(this.props.match.params.accountId, null)

    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}/cash/gst-bank/net-cash-flow`,
      cacheKey: cacheKey,
      callback: this.getNetCashFlowCallback,
      ttlInSecs: 600
    })

    let params = {}
    if (fromYearMonth && toYearMonth) {
      params.fromYearMonth = fromYearMonth
      params.toYearMonth = toYearMonth
    } else if (months) {
      params.months = months
    }

    cacheManager.getObject2(context, null, params)
  }

  getNetCashFlowCallback = (response) => {
    this.setState({ netCashFlowList: response.netCashFlowList, submitted: false, cleared: false })
  }
}

export default withRouter(TriangulationPageSF)
